export enum UserRole {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  VIEWER = 'VIEWER',
  BUILDING_ADMIN = 'BUILDING_ADMIN',
  CONCIERGE = 'CONCIERGE',
  MASTER = 'MASTER',
}

export enum UserRoleTranslations {
  MASTER = 'common:roles.master',
  ADMIN = 'common:roles.admin',
  OWNER = 'common:roles.owner',
  VIEWER = 'common:roles.viewer',
  BUILDING_ADMIN = 'common:roles.buildingAdmin',
  CONCIERGE = 'common:roles.concierge',
}
